import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { fadeInOut } from "src/app/common/animations/animations";

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"],
  animations: [fadeInOut],
})
export class WelcomeComponent implements OnInit {
  @Output() onRoute = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {
    if (localStorage) {
      localStorage.clear();
    }
  }

  changeRoute() {
    this.onRoute.emit();
  }
}
